/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_SubmitInputs */

const en_us2_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const pt_br2_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const es_419_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const pt_pt2_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const fr_fr2_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const de_de2_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const it_it2_auth_code_submit = /** @type {(inputs: Auth_Code_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Code_SubmitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_submit = /** @type {((inputs?: Auth_Code_SubmitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_SubmitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_submit(inputs)
	if (locale === "es-419") return es_419_auth_code_submit(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_submit(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_submit(inputs)
	if (locale === "de-DE") return de_de2_auth_code_submit(inputs)
	if (locale === "it-IT") return it_it2_auth_code_submit(inputs)
	return en_us2_auth_code_submit(inputs)
});
export { auth_code_submit as "auth.code_submit" }